<template>
    <div>
        <slot name="heading"
              :has-previous="hasPrevious"
              :has-next="hasNext"
              :previous-month="previousMonth"
              :next-month="nextMonth"
              :current-month="selectedMonth">
            <button class="btn btn-primary" v-if="hasPrevious" @click="previousMonth">Previous</button>
            {{ selectedMonth && selectedMonth.text }}
            <button class="btn btn-primary" v-if="hasNext" @click="nextMonth">Next</button>
        </slot>

        <div class="container-fluid calendar--wrapper">
            <!-- Days -->
            <div v-sticky="{ zIndex: 100, stickyTop: 0, className: 'sticky-buttons' }">
                <div class="row flex-nowrap">
                    <div class="col calendar--header" v-for="day in days" :key="day">
                        {{ day | dayFormat }}
                    </div>
                </div>
            </div>

            <!-- Day cells -->
            <div class="row flex-nowrap" v-for="(week, weekIndex) in weeks" :key="week.id">
                <div class="col calendar--day--container"
                     v-for="(day, dayIndex) in week.days"
                     :id="id(weekIndex, dayIndex, day.value)"
                     :key="day.id"
                     :class="classesFor(day)"
                     @click="clickIfAvailable(day)"
                     tabindex="0">

                    <div class="calendar--day d-flex justify-content-between">
                        <span>{{ formatCalendarDay(day.value) }}</span>
                    </div>
                    <p v-if='objectCalendar(datesCart,formatDate(day.value)).length > 0' class="buy--today--flex text-center" href="/flex">{{objectCalendar(datesCart,formatDate(day.value)).totalQuantity}} Tickets Comprados para esta fecha</p>
                    <p v-else-if="day.value.format('YYYY-MM-DD') == daySelected && dayPrice > 0">{{ formatMoney(dayPrice) }}</p>
                    <calendar-day-event :event="eventFor(day)"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Moment from 'moment';

    import VueSticky from 'vue-sticky'

    import {extendMoment} from 'moment-range';
    import CalendarDayEvent from './CalendarDayEvent';
    import siteConfig from '../mixins/siteConfig';
    import cartMixin from '../mixins/cartMixin';
    const moment = extendMoment(Moment);
    moment.locale('es', {
        week: {
            dow : 1,
        }
    });

    const today = moment().format('YYYY-MM-DD');

    export default {
        name: 'Calendar',

        components: {CalendarDayEvent},

        directives: {
            'sticky': VueSticky,
        },

        mixins: [cartMixin, siteConfig],

        props: {
            days: {
                type: Array,
                default() {
                    return [
                        'Monday',
                        'Tuesday',
                        'Wednesday',
                        'Thursday',
                        'Friday',
                        'Saturday',
                        'Sunday'
                    ];
                }
            },

            startDate: {},

            endDate: {},

            events: {
                type: Object,
                default() {
                    return {}
                }
            },

            dayClick: {
                type: Function,
                default() {
                    return () => ({});
                }
            }
        },

        data() {
            return {
                weeks: [],
                months: [],
                selectedMonth: null,
                selectedDays: {},
                log: true,
                monthLabels: [
                    this.getTranslation('januaryLabel'),
                    this.getTranslation('februaryLabel'),
                    this.getTranslation('marchLabel'),
                    this.getTranslation('aprilLabel'),
                    this.getTranslation('mayLabel'),
                    this.getTranslation('juneLabel'),
                    this.getTranslation('julyLabel'),
                    this.getTranslation('augustLabel'),
                    this.getTranslation('septemberLabel'),
                    this.getTranslation('octoberLabel'),
                    this.getTranslation('novemberLabel'),
                    this.getTranslation('decemberLabel')
                ],
                dayPrice: 0,
                daySelected: today,
            }
        },

        filters: {
            number(date) {
                return date.format('DD');
            },

            dayFormat(value) {
                return value.substr(0, 1).toUpperCase() + value.substr(1, 1).toLowerCase();
            },
        },

        mounted() {
            this.diffBetweenDates(
                moment(this.startDate),
                moment(this.endDate)
            );

            Bus.$on('select-calendar-day', () => {
                if(this.isStoreOpen()) {
                    let stock = this.getStock(this.shortFormat(this.$store.state.fixTicketDefaultDate));
                    if (this.stockAvailable(stock)) {
                        console.log('stock available')
                        console.log(stock)
                        this.$nextTick(() => this.onDayClick({
                            value: this.$store.state.fixTicketDefaultDate
                        }));
                    }
                }
            });
            Bus.$on('unselect-calendar-day', () => this.selectedDays = {})
        },

        watch: {
            selectedMonth({value}) {
                const id = value.toLowerCase(),
                    el = document.querySelector(`#${id}`);

                if (el) el.scrollIntoView({
                    behavior: 'smooth'
                });
            },

            startDate() {
                this.diffBetweenDates(
                    moment(this.startDate),
                    moment(this.endDate)
                );
            },
            selectedFixEvent() {
                this.dayPrice = this.selectedFixEvent ? this.selectedFixEvent.price : 0;
            }
        },

        computed: {
            hasPrevious() {
                if (!this.selectedMonth) return false;
                const index = this.getMonthIndex();
                return index !== 0;
            },

            hasNext() {
                if (!this.selectedMonth) return false;
                const index = this.getMonthIndex();
                return index < this.months.length - 1;
            },

            localEvents() {
                return {...this.events, ...this.defaultEvent};
            },
            datesCart(){
                return this.products.map((product) => {
                    return {"start_date":product.start_date,
                            "quantity":product.quantity
                    }
                    });
            },
            selectedFixEvent() {
                return this.$store.state.selectedFixEvent && this.$store.state.selectedFixEvent.ticket
                    ? this.$store.state.selectedFixEvent
                    : undefined;
            },
        },

        methods:
            {

            objectCalendar(arraydate,date){
               let filterDay = arraydate.filter((objectDate)=>{
                   return objectDate.start_date == date
               })

               const sumValue = filterDay.map((day)=>{
                   return day.quantity
               })

               const totalQuantity = sumValue.reduce((a, b) => a + b, 0)

               filterDay.totalQuantity = totalQuantity

               return filterDay

            },

            formatCalendarDay(date) {
                const day = date.format('DD');
                const month = this.monthLabels[date.format('M') - 1].slice(0, 3);
                return `${day} ${month}`
            },
            formatDate(date) {
                const day = date.format('Y-MM-DD');
                return `${day}`
            },

            translateMonth(date) {
                return this.monthLabels[date.format('M') - 1];
            },

            capitalize(value) {
                return value.substr(0, 1).toUpperCase() + value.substr(1).toLowerCase();
            },

            getMonthIndex() {
                return this.months.findIndex(m => m.id === this.selectedMonth.id);
            },

            previousMonth() {
                const index = this.getMonthIndex();
                this.selectedMonth = this.months[index - 1];
            },

            nextMonth() {
                const index = this.getMonthIndex();
                this.selectedMonth = this.months[index + 1];
            },

            diffInDays(d1, d2) {
                return this.diff(d1, d2, 'days');
            },

            diffInWeeks(d1, d2) {
                return this.diff(d1, d2, 'weeks');
            },

            diffInMonths(d1, d2) {
                const date1 = moment(d1).set('date', 1);
                const date2 = moment(d2).set('date', 1);
                return this.diff(date1, date2, 'months', true);
            },

            /**
             * Calculate diff between two dates
             *
             * @param d1 - from, instance of moment
             * @param d2 - to, instance of moment
             * @param measurement - weeks, days, months, year, hours, minutes or seconds
             * @param floatingPointNumber
             * @returns {*|number}
             */
            diff(d1, d2, measurement, floatingPointNumber) {
                return d2.diff(d1, measurement, !!floatingPointNumber);
            },

            diffBetweenDates(date1, date2) {
                date1.startOf('isoWeek');
                const diffInDays = this.diffInDays(date1, date2);
                const diffInWeeks = this.diffInWeeks(date1, date2);
                const diffInMonths = Math.ceil(this.diffInMonths(date1, date2));
                const weeks = diffInWeeks + 1;

                this.months = [];
                for (let index = 0; index <= diffInMonths; index++) {
                    const month = moment(date1).add(index, 'month');
                    const nextMonth = month.format('MMMM');

                    this.months.push({id: this.uui(), value: nextMonth, text: this.capitalize(this.translateMonth(month))})
                }
                this.selectedMonth = this.months[0];

                this.buildWeeks(date1, weeks, diffInDays);
            },

            buildWeeks(date1, weeks) {
                this.weeks = Array(weeks)
                .fill([])
                .map((_, index) => ({id: this.uui(), days: this.addDays(date1, index)}));
            },

            addDays(initialDate, weekIndex) {
                const start = weekIndex * 7;
                return Array(7).fill().map((_, index) => {
                    const value = moment(initialDate).add(start + index, 'day');

                    return {id: this.uui(), value};
                });
            },

            isFirstDayOfMonth(weekIndex, dayIndex, day) {
                return weekIndex === 0 && dayIndex === 0
                    || parseInt(day.format('D')) === 1;
            },

            id(weekIndex, dayIndex, day) {
                return this.isFirstDayOfMonth(weekIndex, dayIndex, day)
                    ? day.format('MMMM').toLowerCase()
                    : '';
            },

            uui() {
                return Math.random() * 100000000;
            },

            shortFormat(date) {
                return date.format('YYYY-MM-DD');
            },

            hasDayEvent(day) {
                const d = this.shortFormat(day.value);

                return this.localEvents[d];
            },

            eventFor(day) {
                const d = this.shortFormat(day.value);
                return this.localEvents[d];
            },

            classesFor(day) {
                const d = this.shortFormat(day.value);
                const classes = (this.selectedDays[d] || {}).classes || [];

                classes.push(
                    day.value.format('M') % 2 === 0 ? 'is--even--month' : 'is--odd--month'
                );

                if (today === d) {
                    classes.push('is--today');
                }

                return classes;
            },

            getStock(input_date) {
                return this.$store.state.stockDate.find(stock_date => stock_date.date == input_date);
            },

            clickIfAvailable(day) {
                if (this.isStoreOpen(day.value)) {
                    let stock = this.getStock(this.shortFormat(day.value));
                    if (this.stockAvailable(stock)) {
                        let preformat_date = this.shortFormat(day.value).split('-');
                        day.value._d = new Date(preformat_date.join('/'));
                        this.onDayClick(day);
                    }
                }
            },

            stockAvailable(stock) {
                return true;
                // return stock && stock.current_fix_tickets_stock > 0 ? true : false;
            },

            isStoreOpen(input_date = null) {
                if (input_date) {
                    var today = moment();
                    if (today.format('DD-MM-YYYY') === input_date.format('DD-MM-YYYY'))
                        return false;
                }
                return true
            },

            onDayClick(day) {
                // this.dayPrice = this.selectedFixEvent ? this.selectedFixEvent.price : 0;
                this.daySelected = day.value.format('YYYY-MM-DD')
                if (!this.hasDayEvent(day)) {
                    this.dayClick();
                    return this.selectedDays = {};
                }

                const {duration} = this.eventFor(day),
                    {value: d} = day,
                    toDate = moment(d).add(duration - 1, 'days'),
                    range = moment().range(d, toDate),
                    days = Array.from(range.by('days'));

                this.selectedDays = {};

                days.forEach((day, index) => {
                    const classes = index === 0 ? ['highlight', 'first--highlight'] : ['highlight'];

                    this.selectedDays[this.shortFormat(day)] = {
                        classes
                    }
                });

                this.dayClick(this.shortFormat(day.value));
            },
            formatMoney(money){
                const formatter = new Intl.NumberFormat('es-CL', {
                    style: 'currency',
                    currency: 'CLP',
                });
                return formatter.format(money);

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Calendar.vue